import { createBrowserRouter, Navigate, Outlet, type RouteObject } from 'react-router-dom';
import { AppLayout } from '../layout/AppLayout';
import { LoginPage } from '../pages/LoginPage';
import { AuthProvider } from '../auth/AuthProvider';
import { RequireAdmin } from '../auth/RequireAdmin';
import { DashboardPage } from '../pages/DashboardPage';
import { FunnelPage } from '../pages/FunnelPage';
import { CheckoutsPage } from '../pages/CheckoutsPage';
import { CheckoutDetailsPage } from '../pages/CheckoutDetailsPage';
import { EventsPage } from '../pages/EventsPage';
import { RemarketingPage } from '../pages/RemarketingPage';
import { OrganizerRemarketingRoute } from '../organizer/OrganizerRemarketingRoute';

/** Sessão administrativa (cookie HttpOnly) só existe para o login e o painel. */
function AdminSessionBoundary() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

export const routes: RouteObject[] = [
  // Área do organizador, aberta pelo Gestão num iframe. Fica FORA da sessão
  // administrativa: nem RequireAdmin, nem AuthContext — a credencial é o token
  // temporário do organizador, em memória (ver src/organizer/).
  { path: '/organizer/remarketing', element: <OrganizerRemarketingRoute /> },
  {
    element: <AdminSessionBoundary />,
    children: [
      { path: '/login', element: <LoginPage /> },
      {
        path: '/',
        // Sem sessão administrativa, nenhuma tela do painel monta.
        element: (
          <RequireAdmin>
            <AppLayout />
          </RequireAdmin>
        ),
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'funnel', element: <FunnelPage /> },
          { path: 'checkouts', element: <CheckoutsPage /> },
          { path: 'checkouts/:checkoutId', element: <CheckoutDetailsPage /> },
          { path: 'events', element: <EventsPage /> },
          { path: 'remarketing', element: <RemarketingPage /> },
          { path: '*', element: <Navigate to="/dashboard" replace /> }
        ]
      }
    ]
  }
];

export const router = createBrowserRouter(routes);
